import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { CustomPreloadingStrategyService } from './custom-preloading-strategy.service';
import { HomePluginComponent } from './pages/home-plugin/home-plugin.component';
import { HomePluginGuard } from './pages/home-plugin/home-plugin.guard';

const appRoutes: Routes = [
    {
        path: 'error',
        data: { preload: false },
        loadChildren: () => import('./pages/error/error.module').then(m => m.ErrorModule)
    },
    {
        path: 'filedownload',
        data: { preload: false },
        loadChildren: () => import('./components/file-download/file-download.module').then(m => m.FileDownloadModule)
    },
    {
        path: 'demo',
        data: { preload: false },
        loadChildren: () => import('./pages/demo/demo.module').then(m => m.DemoModule)
    },
    {
        path: 'sso',
        data: { preload: false },
        loadChildren: () => import('./pages/sso/sso.module').then(m => m.SsoModule)
    },
    {
        path: 'printpreview',
        data: { preload: false },
        loadChildren: () => import('./pages/print/print.module').then(m => m.PrintModule)
    },
    {
        path: 'pluginentry/:id',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: false }
    },
    {
        path: 'entitydialog',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: false }
    },
    {
        path: 'contactdialog',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: false }
    },
    {
        path: 'addinall',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: true }
    },
    {
        path: 'addinonlyemail',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: true }
    },
    {
        path: 'addinonlyfile',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: true }
    },
    {
        path: 'pluginevent/:id',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: false }
    },
    {
        path: 'new/popoutentry/:id',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: false }
    },
    {
        path: 'draft/popoutentry/:id',
        component: HomePluginComponent,
        canActivate: [HomePluginGuard],
        data: { preload: false }
    },
    {
        path: 'rc-dashboard/:id',
        data: { preload: false },
        loadChildren: () => import('./pages/rich-client-dashboard/rich-client-dashboard.module').then(m => m.RichClientDashboardModule)
    },
    {
        path: 'print-dashboard/:id',
        data: { preload: false },
        loadChildren: () => import('./pages/print-dashboard/print-dashboard.module').then(m => m.PrintDashboardModule)
    },
    {
        path: 'login',
        data: { preload: true },
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'webplugin',
        data: { preload: true },
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
    },
    {
        path: '',
        data: { preload: true, loadAfterSeconds: 3 },
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
    },
    { path: '**', redirectTo: 'error' }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { preloadingStrategy: CustomPreloadingStrategyService, useHash: environment.isOfficeAddin })],
    providers: [CustomPreloadingStrategyService],
    exports: [RouterModule],
})
export class AppRoutingModule { }
